/* global Ladda */
(function ($) {
    'use strict';
    const keyCodes = {
        Enter: 13
    };
    $.widget("fd.control_tags", {
        options: {
            parentid: null,
            rendertofield: null,
            provider: null
        },

        _create: function () {
            if (!this.options.parentid) {
                this.options.parentid = this.element.closest('[data-fd-parentid]').data('fd-parentid');
            }
            var $element = this.element;
            var options = this.options;
            $element.select2({
                tags: true,
                multiple: true,
                minimumInputLength: 1,
                language: {
                    inputTooShort: function () {
                        return '2 characters needed';
                    }
                },
                createSearchChoice: function (term, data) {
                    if ($(data).filter(function () {
                        return this.text.localeCompare(term) === 0;
                    }).length === 0) {
                        return {
                            id: term,
                            text: term
                        };
                    }
                },
                createTag: function (params) {
                    var term = $.trim(params.term);

                    if (term === '') {
                        return null;
                    }

                    return {
                        id: 0,
                        text: term + '*'
                    };
                },
                ajax: {
                    delay: 350,
                    url: options.provider,
                    dataType: "json",
                    data: function (data, page) {
                        return {
                            term: data.term
                        };
                    },
                    results: function (data, page) {
                        return {
                            results: data
                        };
                    }
                }
            });

            this._setEvents();
            this.element.trigger('change');
        },
        _setEvents: function () {
            var options = this.options;
            this.element.on("change", function (e) {
                var jsonItems = [];
                var selectItems = $(this).find("option");
                for (var i = 0; i < selectItems.length; i++) {
                    var item = selectItems[i];
                    if (item.selected)
                        jsonItems.push({ id: item.value, name: item.text });
                }
                var json = JSON.stringify(jsonItems);
                $("#" + options.rendertofield).val(json);
            });
        },
    });
}(jQuery));